export enum BenefitCategory {
Money,
Object,
Service,
}
